import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=6ef3b1cb&scoped=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"
import style0 from "./Game.vue?vue&type=style&index=0&id=6ef3b1cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef3b1cb",
  null
  
)

export default component.exports